<template>
  <div v-if="showUpdateNotification" class="update-notification">
    <div class="notification-icon">
      <img src="/resources/images/new-ui/aya-icon.svg" alt="Aya Icon" />
    </div>
    <div class="notification-content">
      <p>
        Hey! I notice some changes to the codebase. In order to see them, please
        click this refresh button.
      </p>
      <button @click="refreshApp" class="refresh-button">Refresh</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateNotification',
  data() {
    return {
      showUpdateNotification: false,
      checkInterval: null,
    }
  },
  created() {
    // Check for updates when component is created
    this.checkForUpdates()
    // Check every 5 minutes (adjust as needed)
    this.checkInterval = setInterval(this.checkForUpdates, 5 * 60 * 1000)
    // A tab left open for days is checked again the moment it is looked at.
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  },
  beforeDestroy() {
    // Clean up interval when component is destroyed
    clearInterval(this.checkInterval)
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  },
  methods: {
    onVisibilityChange() {
      if (document.visibilityState === 'visible') this.checkForUpdates()
    },
    async checkForUpdates() {
      try {
        // version.json is written by the build (vue.config.js) with the commit
        // it was built from; this tab's own build carries the same value.
        const response = await fetch('/version.json?t=' + new Date().getTime())
        const data = await response.json()
        console.log('data', data)

        // Compared with this tab's own build, not a value shared through
        // localStorage: with two tabs open, the first one to see a deploy
        // used to store the new version and the stale tab never prompted.
        const runningVersion = process.env.VUE_APP_BUILD_VERSION
        if (data.version && runningVersion && data.version !== runningVersion) {
          this.showUpdateNotification = true
        }
      } catch (error) {
        console.error('Failed to check for updates:', error)
      }
    },
    refreshApp() {
      // Clear browser cache for the current page
      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name)
          })
        })
      }
      window.location.reload(true)
    },
  },
}
</script>

<style scoped>
.update-notification {
  position: fixed;
  top: 30px;
  right: 30px;
  background-color: white;
  color: #152f4a;
  padding: 10px;
  border-radius: 12px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  z-index: 9999;
  max-width: 365px;
  font-family: 'Poppins', sans-serif;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.notification-icon {
  flex-shrink: 0;
  color: #9764f7;
  margin-top: 2px;
}

.notification-content {
  padding-right: 20px;
  flex-grow: 1;
}

.notification-content p {
  margin-bottom: 0;
  padding-right: 15px;
  font-size: 12px;
  line-height: 1.5;
  color: #152f4a;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
}

.refresh-button {
  background-color: #9764f7;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 4px 13px;
  cursor: pointer;
  font-weight: 500;
  font-size: 9px;
  transition: background-color 0.2s ease;
  font-family: 'Poppins', sans-serif;
  float: right;
}

.refresh-button:hover {
  background-color: #8753f6;
}
</style>
